"use client"
import React from "react"

const LayoutClient = ({children}:{children: React.ReactNode}) => {
  return <>{children}</>
}

export default LayoutClient
